export default "__VITE_ASSET__7ec861dc__"